<template>
  <div id="app">
    <div @mousemove="updateActivity" @keydown="updateActivity"></div>
    <router-view />
  </div>
</template>

<script>
import { onMounted, onBeforeUnmount, computed } from 'vue';//computed
import { useStore } from 'vuex';
// import axios from 'axios';

export default {
  setup() {
    const store = useStore();
    const lastActivity = computed(() => store.state.lastActivity);
    console.debug("lastActivity", lastActivity)
    const updateActivity = () => {
      store.dispatch('updateLastActivity');
    };

    // const handleBeforeUnload = () => {
    //   // 在页面关闭前发送请求减少连接数 
    //   axios.get(`${process.env.VUE_APP_API_URL}/connection/decrease/`)
    //     .then(() => {
    //       console.log('連線數已減少');
    //     })
    //     .catch(error => {
    //       console.error('錯誤:', error);
    //     });
    // };

    onMounted(() => {
      // 當組件掛載時，檢查登入狀態並定期檢查是否超時
      store.dispatch('checkLoginStatus');

      //定期檢查超時
      const checkInterval = setInterval(() => {
        store.dispatch('checkLoginStatus');
      }, 60000); // 每60秒检查一次

      // 当组件挂载时，发送请求到服务器以触发中间件计算连线数
      // axios.get(`${process.env.VUE_APP_API_URL}/connection/increase/`)
      //   .then(() => {
      //     console.log('連線數已增加');
      //   })
      //   .catch(error => {
      //     if (error.response && error.response.status === 403) {
      //       alert('連線數已達上限，請稍後再試。');
      //       window.location.href = 'https://www.google.com.tw/';
      //     } else {
      //       console.error('錯誤:', error);
      //     }
      //   });

      // 监听页面关闭事件，发送请求减少连接数
      // window.addEventListener('beforeunload', handleBeforeUnload);

      // 清除定时器
      onBeforeUnmount(() => {
        clearInterval(checkInterval);
        // window.removeEventListener('beforeunload', handleBeforeUnload);
      });
    });

    return {
      updateActivity,
    };
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
